module.exports = __webpack_public_path__ + "img/fight.556550e9.jpg";